export default __webpack_public_path__ + "71b735e367a1955af105245848751c11.png";